import {
  call,
  put,
  takeEvery,
  takeLatest,
  delay,
  cancel,
  fork,
  take,
  all,
} from "redux-saga/effects";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  UPLOAD_NMAP_FILES,
  SET_NMAP_LOADER,
  NMAP_FILE_UPLOAD,
  NMAP_UPLOAD_UNSUCCESSFUL,
  SET_NETSPACE_LOADER,
  SET_NETSPACE_SNACKBAR,
  GET_HOST_WITH_ALERTS,
  HOST_WITH_ALERT_URL,
  SET_HOST_WITH_ALERT,
  GET_SECURITY_ALERTS,
  SECURITY_ALERTS_URL,
  SET_SECURITY_ALERTS,
  GET_VISIBILITY,
  VISIBILITY_URL,
  SET_VISIBILITY,
  GET_CRITICALITY,
  SET_CRITICALITY,
  CRITICALITY_URL,
  GROUPS_URL,
  SET_GROUPS,
  GET_GROUP_BY,
  UPDATE_SELECTED_GROUP,
  GROUP_COUNT_URL,
  SET_GROUP_COUNT,
  SET_SELECTED_GROUP,
  GET_GROUP_BY_DATA,
  formFinalURL,
  SET_ACCORDION_DATA,
  DEFAULT,
  SAVE_TAGS,
  SAVE_TAGS_URL,
  CHANGE_TAG_MODAL_STATUS,
  GET_ACTIVE_NETMAP,
  GET_NETMAP_STATUS,
  GET_ACTIVE_NETMAP_URL,
  GET_NETMAP_STATUS_URL,
  SET_NETMAP_PROGRESS,
  FETCH_FILE_STATUS_CANCEL,
  SET_ACTIVE_NETMAP,
  SET_FILE_EDITABLE,
  FILE_COMPLETED_STATUS,
  SET_RELOAD_NETSPACE,
  SYSTEM_TAGS,
  getSecondDropdownAPI,
  SET_SYSTEM_TAGS_DROPDOWN,
  SET_USER_TAGS_DROPDOWN,
  GET_SECOND_TAGS_DROPDOWN,
  USER_TAGS,
  GET_TAG_VALUES,
  getTagName,
  getSecondTagsDropdownValuesAPI,
  GET_SUB_TAG_DATA,
  getSubTagDataAPI,
  DELETE_USER_TAG,
  DELETE_USER_TAG_URL,
  GET_CVE_BY_SEVERITIES,
  FETCH_CVE_BY_SEVERITIES,
  SET_CVE_BY_SEVERITIES,
  FETCH_HIGHEST_CVE_SEVERITY,
  GET_HIGHEST_CVE_SEVERITY,
  SET_HIGHEST_CVE_SEVERITY,
  SET_CVE_IDS,
  VULNERABILITY_ID,
  SET_OS_TYPES,
  GET_OS_TYPES,
  SET_SOURCE_TYPES,
  GET_SOURCE_TYPES,
  GET_CVE_BY_SEVERITIES_DASHBOARD,
  SET_CVE_BY_SEVERITIES_DASHBOARD,
  GET_CVE_IDS,
  SET_CVE_IDS_DASHBOARD,
  GET_HIGHEST_CVE_SEVERITY_DASHBOARD,
  SET_HIGHEST_CVE_SEVERITY_DASHBOARD,
  GET_SIDE_DRAWER_ALERTS,
  getSideDrawerAlertsAPI,
  SET_SIDE_DRAWER_ALERTS,
  SET_CVE_LIST_BY_SEVERITY,
  GET_CVE_LIST_BY_SEVERITY,
  UPDATE_HOST_STATUS,
  UPDATE_HOST_STATUS_URL,
  EXPORT_NETSPACE_HOSTS_CSV,
  EXPORT_NETSPACE_HOSTS_CSV_URL,
} from "./NetSpaceConstant";
import { isFileProcessCompleted } from "./NetSpaceUtils";
import { chunk, get, method, set } from "lodash";
import { domain_vizr } from "../DataGuard/Utility/DataguardConstant";

function* uploadNmapFile(action) {
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "POST",
      url: NMAP_FILE_UPLOAD,
      data: action.payload.formData,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200) {
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
      yield put({ type: SET_FILE_EDITABLE, payload: false });
      yield call(getNmapStatus);
    } else {
      const error = res.response && res.response.data;
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
      yield put({ type: FETCH_FILE_STATUS_CANCEL });
      yield put({ type: SET_FILE_EDITABLE, payload: false });
      yield put({
        type: SET_NETSPACE_SNACKBAR,
        payload: { status: true, message: error.errorMessage },
      });
    }
  } catch (e) {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
    yield put({
      type: SET_NETSPACE_SNACKBAR,
      payload: { status: true, message: NMAP_UPLOAD_UNSUCCESSFUL },
    });
  }
}

function* getHostWithAlerts() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_HOST_WITH_ALERTS, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: HOST_WITH_ALERT_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_HOST_WITH_ALERTS, value: false },
      });
      yield put({
        type: SET_HOST_WITH_ALERT,
        payload: { hostWithAlert: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_HOST_WITH_ALERTS, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_HOST_WITH_ALERTS, value: false },
    });
  }
}

function* getSecurityAlerts() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_SECURITY_ALERTS, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: SECURITY_ALERTS_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SECURITY_ALERTS, value: false },
      });
      yield put({
        type: SET_SECURITY_ALERTS,
        payload: { securityAlerts: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SECURITY_ALERTS, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_SECURITY_ALERTS, value: false },
    });
  }
}

function* getVisibility() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_VISIBILITY, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: VISIBILITY_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_VISIBILITY, value: false },
      });
      yield put({
        type: SET_VISIBILITY,
        payload: { visibility: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_VISIBILITY, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_VISIBILITY, value: false },
    });
  }
}

function* getCriticality() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_CRITICALITY, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: CRITICALITY_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CRITICALITY, value: false },
      });
      yield put({
        type: SET_CRITICALITY,
        payload: { criticality: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CRITICALITY, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_CRITICALITY, value: false },
    });
  }
}

function* getOSTypes() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_OS_TYPES, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL["OS"],
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_OS_TYPES, value: false },
      });
      yield put({
        type: SET_OS_TYPES,
        payload: { osTypes: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_OS_TYPES, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_OS_TYPES, value: false },
    });
  }
}

function* getHighestCVESeverityDashboard() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_HIGHEST_CVE_SEVERITY_DASHBOARD, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL["VULNERABLE_HOSTS"],
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_HIGHEST_CVE_SEVERITY_DASHBOARD, value: false },
      });
      yield put({
        type: SET_HIGHEST_CVE_SEVERITY_DASHBOARD,
        payload: { highestCVESeverityDashboard: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_HIGHEST_CVE_SEVERITY_DASHBOARD, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_HIGHEST_CVE_SEVERITY_DASHBOARD, value: false },
    });
  }
}

function* getCVEIds() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_CVE_IDS, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL["VULNERABILITY_ID"],
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CVE_IDS, value: false },
      });
      yield put({
        type: SET_CVE_IDS_DASHBOARD,
        payload: { cveIdsDashboard: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CVE_IDS, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_CVE_IDS, value: false },
    });
  }
}

function* getSourceTypes() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_SOURCE_TYPES, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL["AGENTS"],
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SOURCE_TYPES, value: false },
      });
      yield put({
        type: SET_SOURCE_TYPES,
        payload: { sourceTypes: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SOURCE_TYPES, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_SOURCE_TYPES, value: false },
    });
  }
}

function* getCveBySeveritiesDashboard() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_CVE_BY_SEVERITIES_DASHBOARD, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL["VULNERABILITIES"],
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CVE_BY_SEVERITIES_DASHBOARD, value: false },
      });
      yield put({
        type: SET_CVE_BY_SEVERITIES_DASHBOARD,
        payload: { cveBySeverityDashboard: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_CVE_BY_SEVERITIES_DASHBOARD, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_CVE_BY_SEVERITIES_DASHBOARD, value: false },
    });
  }
}

function* getGroups() {
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "GET",
      url: GROUPS_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
      yield put({
        type: SET_GROUPS,
        payload: { groups: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    }
  } catch (e) {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* setSelectedGroup(action) {
  const { group, place } = action.payload;

  if (place !== "widget") {
    yield put({ type: UPDATE_SELECTED_GROUP, payload: group });
  }

  try {
    const res = yield getService({
      method: "GET",
      url: GROUP_COUNT_URL[group],
      headers: getAxiosHeaders(true),
    });

    if (res && res.status === 200 && res.data) {
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
      yield put({
        type: SET_GROUP_COUNT,
        payload: { groupCount: res.data },
      });

      if (place === "widget") {
        yield put({ type: SET_CVE_IDS, payload: { groupCount: res.data } });
      }
    } else {
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    }
  } catch (e) {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* fetchGroupAccordionData({ key, value, pageNo, pageSize }) {
  try {
    const res = yield call(getService, {
      method: "GET",
      url: formFinalURL(key, value, pageNo, pageSize),
      headers: getAxiosHeaders(true),
    });

    if (res && res.status === 200 && res.data) {
      return { key: value, data: res.data };
    }
  } catch (e) {
    console.error(`Failed to fetch group data for ${value}:`, e);
  }
  return null;
}

function* getGroupData(action) {
  const { key, values, pageNo, pageSize } = action.payload;

  yield put({ type: SET_NETSPACE_LOADER, payload: true });

  try {
    const keyChunks = chunk(values, 10);

    for (let group of keyChunks) {
      const results = yield all(
        group.map((value) =>
          call(fetchGroupAccordionData, { key, value, pageNo, pageSize }),
        ),
      );

      const batchedData = {};
      group.forEach((val, index) => {
        const res = results[index];
        if (res && res.data && res.key !== undefined) {
          batchedData[res.key] = res.data;
        }
      });

      yield put({
        type: SET_ACCORDION_DATA,
        payload: {
          batchedAccordionData: batchedData,
        },
      });

      yield delay(50);
    }
  } catch (e) {
    console.error("Batch group data error:", e);
  } finally {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* fetchCveListBySeverity({ payload }) {
  try {
    const { severity } = payload;

    const res = yield call(getService, {
      method: "GET",
      url: `${domain_vizr}/tenant/netSpace/cveIds?severity=${severity}`,
      headers: getAxiosHeaders(true),
    });

    if (res?.status === 200 && res.data) {
      yield put({
        type: SET_CVE_LIST_BY_SEVERITY,
        payload: {
          severity,
          cveMap: res.data,
        },
      });
    }
  } catch (e) {
    console.error("CVE list fetch failed:", e);
  }
}

function* saveTags(action) {
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "POST",
      url: SAVE_TAGS_URL + action.payload.hostId,
      headers: getAxiosHeaders(true),
      data: action.payload.tags,
    });
    if (res && res.status === 200) {
      yield put({
        type: CHANGE_TAG_MODAL_STATUS,
        payload: {
          isTagModalOpen: false,
          selectedTagData: null,
          selectedTagNodeId: null,
        },
      });
      yield call(getGroupData, {
        payload: {
          key: action.payload.loadGroupData?.key,
          values: [action.payload.loadGroupData?.value],
          pageNo: action.payload.loadGroupData?.pageNo,
          pageSize: action.payload.loadGroupData?.pageSize,
        },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    }
  } catch (e) {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* updateHostStatus(action) {
  const { hostId, status, loadGroupData } = action.payload;
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "PUT",
      url: UPDATE_HOST_STATUS_URL,
      headers: getAxiosHeaders(true),
      params: { hostId, status },
    });

    if (res && res.status === 200) {
      if (loadGroupData) {
        yield call(getGroupData, {
          payload: {
            key: loadGroupData.key,
            values: [loadGroupData.value],
            pageNo: loadGroupData.pageNo,
            pageSize: loadGroupData.pageSize,
          },
        });
      }
    } else {
      console.error("Failed to update host status:", res?.response?.data);
    }
  } catch (e) {
    console.error("Exception updating host status:", e);
  } finally {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* exportNetspaceHostsCsv() {
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield call(getService, {
      method: "GET",
      url: EXPORT_NETSPACE_HOSTS_CSV_URL,
      headers: getAxiosHeaders(true),
      responseType: "blob",
    });

    if (res && res.status === 200) {
      const fileName =
        extractFileName(res.headers?.["content-disposition"]) ||
        "netspace_hosts_export.csv";

      downloadBlob(res.data, fileName);
    } else {
      console.error("Failed to export hosts CSV:", res?.response?.data);
    }
  } catch (e) {
    console.error("Exception exporting hosts CSV:", e);
  } finally {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function downloadBlob(blobData, fileName) {
  const blob = new Blob([blobData], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function extractFileName(contentDisposition) {
  if (!contentDisposition) {
    return null;
  }
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  return match ? match[1] : null;
}


function* getActiveNmap(action) {
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "GET",
      url: GET_ACTIVE_NETMAP_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
      yield put({
        type: SET_ACTIVE_NETMAP,
        payload: { active_nmap: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    }
  } catch (e) {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* getNmapStatus() {
  try {
    let previousStatus = null;
    while (true) {
      const res = yield getService({
        method: "GET",
        url: GET_NETMAP_STATUS_URL,
        headers: getAxiosHeaders(true),
      });
      if (res && res.status === 200 && res.data) {
        yield put({
          type: SET_NETMAP_PROGRESS,
          payload: { nmap_progress_data: res.data },
        });
        if (
          previousStatus &&
          res?.data?.status?.code !== previousStatus &&
          !FILE_COMPLETED_STATUS.includes(previousStatus) &&
          FILE_COMPLETED_STATUS.includes(res?.data?.status?.code)
        ) {
          yield put({
            type: SET_RELOAD_NETSPACE,
            payload: true,
          });
        }
        if (FILE_COMPLETED_STATUS.includes(res?.data?.status?.code)) {
          break;
        }
        previousStatus = res?.data?.status?.code;
      } else {
        console.log("getActiveNetMap err=");
        console.log(res);
      }
      yield delay(5000);
    }
  } catch (e) {
    console.log("getActiveNetMap exception=");
    console.log(e);
  }
}

function* watchFetchFileStatus() {
  const task = yield fork(getNmapStatus);
  yield take(FETCH_FILE_STATUS_CANCEL);
  yield cancel(task);
}

function* getSecondTagsDropdown(action) {
  const { selectedTag } = action.payload;
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  try {
    const res = yield getService({
      method: "GET",
      url: getSecondDropdownAPI(getTagName[selectedTag]),
      headers: getAxiosHeaders(true),
    });
    const getReduxKey =
      selectedTag === SYSTEM_TAGS
        ? SET_SYSTEM_TAGS_DROPDOWN
        : SET_USER_TAGS_DROPDOWN;
    if (res && res.status === 200 && res.data) {
      yield put({
        type: getReduxKey,
        payload: res.data,
      });
    } else {
      const error = res.response && res.response.data;
      console.error("Error fetching user tags:", error);
    }
  } catch (e) {
    console.error("Exception fetching user tags:", e);
  }
}

function* getSecondDropDownSubValues(action) {
  const { selectedTag, secondTag, data, page, size } = action.payload;
  const tagValues = data.map((item) => item.value).filter(Boolean);

  if (!tagValues || tagValues.length === 0) return;

  yield put({ type: SET_NETSPACE_LOADER, payload: true });

  const tagChunks = chunk(tagValues, 10);

  for (let group of tagChunks) {
    const results = yield all(
      group.map((value) =>
        call(fetchAccordionData, {
          selectedTag,
          secondTag,
          value,
          page,
          size,
        }),
      ),
    );

    const batchedData = {};
    for (let result of results) {
      if (result && result.data && result.key) {
        batchedData[result.key] = result.data;
      }
    }

    yield put({
      type: SET_ACCORDION_DATA,
      payload: {
        batchedAccordionData: batchedData,
      },
    });

    yield delay(50);
  }

  yield put({ type: SET_NETSPACE_LOADER, payload: false });
}

// Helper to call individual API
function* fetchAccordionData({ selectedTag, secondTag, value, page, size }) {
  const paramData = {};
  if (secondTag) paramData.code = secondTag;
  paramData.value = value;

  const options = {
    method: "GET",
    url: getSubTagDataAPI(getTagName[selectedTag], page, size),
    headers: getAxiosHeaders(true),
    params: paramData,
  };

  try {
    const res = yield call(getService, options);
    if (res && res.status === 200 && res.data) {
      return { key: value, data: res.data };
    }
  } catch (e) {
    console.error(`Error fetching tag value '${value}':`, e);
  }

  return null;
}

function* getTagsValues(action) {
  const { selectedTag, secondTag } = action.payload;
  yield put({ type: UPDATE_SELECTED_GROUP, payload: selectedTag });
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  let paramData = {};
  if (secondTag) {
    paramData.userCode = secondTag;
  }
  const options = {
    method: "GET",
    url: getSecondTagsDropdownValuesAPI(getTagName[selectedTag]),
    headers: getAxiosHeaders(true),
    params: paramData,
  };

  try {
    const res = yield getService(options);
    if (res && res.status === 200 && res.data) {
      const tagValues = res.data.reduce((acc, item) => {
        if (item.value) {
          acc[item.value] = item.count;
        }
        return acc;
      }, {});
      yield put({ type: SET_GROUP_COUNT, payload: { groupCount: tagValues } });
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    } else {
      const error = res.response && res.response.data;
      console.error("Error fetching user tags:", error);
      yield put({ type: SET_NETSPACE_LOADER, payload: false });
    }
  } catch (e) {
    console.error("Exception fetching user tags:", e);
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* deleteUserTag(action) {
  const { id } = action.payload;
  yield put({ type: SET_NETSPACE_LOADER, payload: true });
  const options = {
    method: "DELETE",
    url: DELETE_USER_TAG_URL(id),
    headers: getAxiosHeaders(true),
  };

  try {
    const res = yield getService(options);
    if (res && res.status === 200) {
      console.log("User tag deleted successfully");
    } else {
      const error = res.response && res.response.data;
      console.error("Error deleting user tag:", error);
    }
  } catch (e) {
    console.error("Exception deleting user tag:", e);
  } finally {
    yield put({ type: SET_NETSPACE_LOADER, payload: false });
  }
}

function* fetchHighestCVESeverity() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: FETCH_HIGHEST_CVE_SEVERITY, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GET_HIGHEST_CVE_SEVERITY,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: FETCH_HIGHEST_CVE_SEVERITY, value: false },
      });
      yield put({
        type: SET_HIGHEST_CVE_SEVERITY,
        payload: { highestCVESeverity: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      console.log(error);
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: FETCH_HIGHEST_CVE_SEVERITY, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: FETCH_HIGHEST_CVE_SEVERITY, value: false },
    });
  }
}

function* fetchCVEBySeverities() {
  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: FETCH_CVE_BY_SEVERITIES, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: GET_CVE_BY_SEVERITIES,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: FETCH_CVE_BY_SEVERITIES, value: false },
      });
      yield put({
        type: SET_CVE_BY_SEVERITIES,
        payload: { cveBySeverity: res.data },
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: FETCH_CVE_BY_SEVERITIES, value: false },
      });
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: FETCH_CVE_BY_SEVERITIES, value: false },
    });
  }
}

// ------------------- Side Drawer Alerts ------------------

function* getSideDrawerAlerts(action) {
  const { hostId, page, size, status } = action.payload;
  let paramData = {};
  let statusFilter = "";
  if (status) {
    statusFilter = status;
    paramData["status"] = statusFilter;
  }

  yield put({
    type: SET_NETSPACE_LOADER,
    payload: { key: GET_SIDE_DRAWER_ALERTS, value: true },
  });
  try {
    const res = yield getService({
      method: "GET",
      url: getSideDrawerAlertsAPI(hostId, page, size),
      headers: getAxiosHeaders(true),
      params: paramData,
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SIDE_DRAWER_ALERTS, value: false },
      });
      yield put({
        type: SET_SIDE_DRAWER_ALERTS,
        payload: res.data,
      });
    } else {
      const error = res.response && res.response.data;
      yield put({
        type: SET_NETSPACE_LOADER,
        payload: { key: GET_SIDE_DRAWER_ALERTS, value: false },
      });
      console.error("Error fetching side drawer alerts:", error);
    }
  } catch (e) {
    yield put({
      type: SET_NETSPACE_LOADER,
      payload: { key: GET_SIDE_DRAWER_ALERTS, value: false },
    });
    console.error("Error fetching side drawer alerts:", e);
  }
}

function* NetSpaceSaga() {
  yield takeEvery(UPLOAD_NMAP_FILES, uploadNmapFile);
  yield takeEvery(GET_HOST_WITH_ALERTS, getHostWithAlerts);
  yield takeEvery(GET_SECURITY_ALERTS, getSecurityAlerts);
  yield takeEvery(GET_VISIBILITY, getVisibility);
  yield takeEvery(GET_CRITICALITY, getCriticality);
  yield takeEvery(GET_GROUP_BY, getGroups);
  yield takeEvery(SET_SELECTED_GROUP, setSelectedGroup);
  yield takeLatest(GET_GROUP_BY_DATA, getGroupData);
  yield takeEvery(SAVE_TAGS, saveTags);
  yield takeLatest(GET_NETMAP_STATUS, watchFetchFileStatus);
  yield takeLatest(GET_ACTIVE_NETMAP, getActiveNmap);
  yield takeEvery(GET_SECOND_TAGS_DROPDOWN, getSecondTagsDropdown);
  yield takeEvery(GET_TAG_VALUES, getTagsValues);
  yield takeLatest(GET_SUB_TAG_DATA, getSecondDropDownSubValues);
  yield takeEvery(DELETE_USER_TAG, deleteUserTag);
  yield takeEvery(FETCH_CVE_BY_SEVERITIES, fetchCVEBySeverities);
  yield takeEvery(FETCH_HIGHEST_CVE_SEVERITY, fetchHighestCVESeverity);
  yield takeEvery(GET_OS_TYPES, getOSTypes);
  yield takeEvery(GET_SOURCE_TYPES, getSourceTypes);
  yield takeEvery(GET_CVE_BY_SEVERITIES_DASHBOARD, getCveBySeveritiesDashboard);
  yield takeEvery(GET_CVE_IDS, getCVEIds);
  yield takeEvery(
    GET_HIGHEST_CVE_SEVERITY_DASHBOARD,
    getHighestCVESeverityDashboard,
  );
  yield takeEvery(GET_SIDE_DRAWER_ALERTS, getSideDrawerAlerts);
  yield takeEvery(GET_CVE_LIST_BY_SEVERITY ,fetchCveListBySeverity);
  yield takeEvery(UPDATE_HOST_STATUS, updateHostStatus);
  yield takeEvery(EXPORT_NETSPACE_HOSTS_CSV, exportNetspaceHostsCsv);
}
export default NetSpaceSaga;
